import React, { useState, useEffect } from 'react';

export enum Scripts {
  Checkout,
  Search,
  Flights,
  Maps,
}

type BootstrapProps = {
  scripts?: Scripts[];
};

const Bootstrap: React.FC<BootstrapProps> = ({ children, scripts = [] }) => {
  const [ready, setReady] = useState<boolean>(false);

  useEffect(() => {
    // Product Mofo
    const mofo = document.createElement('script');
    mofo.src = `${SERVICE_HOSTNAME}/sdk.js`;
    mofo.async = true;
    document.body.appendChild(mofo);
    console.log('STAYS PRODUCT MOFO: OK');

    // Stays Shopping Platform
    const platform = document.createElement('script');
    platform.src = `${STAYS_PLATFORM_SERVICE_HOSTNAME}/sdk.js`;
    platform.async = true;
    document.body.appendChild(platform);
    console.log('STAYS SHOPPING PLATFORM: OK');

    scripts.map((script) => {
      if (script === Scripts.Checkout) {
        // Omni Checkout SDK
        const checkout = document.createElement('script');
        checkout.src = 'https://omni-checkout-platform-latest.non-prd.edge.soar.fcl.cloud/sdk.js';
        checkout.async = true;
        document.body.appendChild(checkout);
        console.log('OMNI CHECKOUT PLATFORM: OK');
      }

      if (script === Scripts.Search) {
        // Omni Search Mofo SDK
        const omniSearch = document.createElement('script');
        omniSearch.src = 'https://omni-search-ui-latest.non-prd.edge.soar.fcl.cloud/sdk.js';
        omniSearch.async = true;
        document.body.appendChild(omniSearch);
        console.log('OMNI SEARCH MOFO: OK');
      }

      if (script === Scripts.Flights) {
        // Omni Flights Mofo
        const omniFlights = document.createElement('script');
        omniFlights.src = 'https://omni-flights-shopping-mofo-latest.non-prd.edge.soar.fcl.cloud/sdk.js';
        omniFlights.async = true;
        document.body.appendChild(omniFlights);
        console.log('OMNI FLIGHTS MOFO: OK');
      }

      if (script === Scripts.Maps) {
        // Omni Maps Mofo
        const omniMapsMofo = document.createElement('script');
        omniMapsMofo.src = 'https://omni-maps-mofo-latest.non-prd.edge.soar.fcl.cloud/sdk.js';
        omniMapsMofo.async = true;
        document.body.appendChild(omniMapsMofo);
        console.log('OMNI MAPS MOFO: OK');
      }
    });
    setReady(true);
  }, []);

  return <>{ready && children}</>;
};

export default Bootstrap;
